import React from "react";
import styles from "./BetTableDum10.module.css";

// Import card suit icons
import spadeIcon from '../../../../assets/img/cardsIcons/spade.png';
import clubIcon from '../../../../assets/img/cardsIcons/club.png';
import heartIcon from '../../../../assets/img/cardsIcons/heart.png';
import diamondIcon from '../../../../assets/img/cardsIcons/diamond.png';

const BetTableDum10 = ({ data, onBetClick, exposures = {} }) => {
  const isLocked = (value, betData) => {
    return value === 0 || value === undefined || betData?.gstatus?.toUpperCase() === "SUSPENDED";
  };

  // Normalize string for matching
  const normalizeString = (str) => {
    if (!str) return "";
    return str
      .replace(/\s*\(\s*/g, '(')
      .replace(/\s*\)\s*/g, ')')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  };

  // Get exposure value for a bet
  const getExposure = (betName, displayLabel) => {
    if (!betName && !displayLabel) return 0;

    const exposureKeys = [
      betName,
      betName?.toLowerCase(),
      betName?.toLowerCase().trim(),
      betName?.trim(),
      displayLabel,
      displayLabel?.toLowerCase(),
      displayLabel?.toLowerCase().trim(),
      displayLabel?.trim(),
      normalizeString(betName),
      normalizeString(displayLabel),
    ];

    // Try direct match
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue)) {
          return expValue;
        }
      }
    }

    // Try normalized match against all exposure keys
    const normalizedKey = normalizeString(betName || displayLabel);
    for (const expKey in exposures) {
      const normalizedExpKey = normalizeString(expKey);
      if (normalizedKey === normalizedExpKey) {
        const expValue = parseFloat(exposures[expKey]);
        if (!isNaN(expValue)) {
          return expValue;
        }
      }
    }

    return 0;
  };

  const renderOddsBox = (value, label, type, betData) => {
    const locked = isLocked(value, betData);
    const selectionName = betData?.nat || label;
    const exposure = getExposure(selectionName, selectionName) || getExposure(label, label) || 0;
    const showExposure = exposure !== 0 && !isNaN(exposure);
    const displayExposure = showExposure ? (exposure < 0 ? exposure.toFixed(0) : `+${exposure.toFixed(0)}`) : "0";

    return (
      <div
        onClick={() => !locked && onBetClick(value, betData?.nat || label, type, betData)}
        style={{
          cursor: locked ? 'not-allowed' : 'pointer',
          textAlign: 'center'
        }}
      >
        <span className={`odds ${locked ? "teenpatti-suspended" : ""}`}>
          {!locked && <b>{value || 0}</b>}
        </span>
        <span style={{ display: 'block', color: 'black', fontSize: '12px' }}>{displayExposure}</span>
      </div>
    );
  };

  const renderBetCell = (value, label, type, betData, displayLabel, cardImages = null) => {
    const locked = isLocked(value, betData);
    const selectionName = betData?.nat || label;
    const exposure = getExposure(selectionName, selectionName) || getExposure(label, label) || 0;
    const showExposure = exposure !== 0 && !isNaN(exposure);

    return (
      <div className="col-3">
        <div>
          <p className="d-block mb-0 text-center" style={{ color: "white" }}>
            {cardImages ? (
              <span className="card-icon" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                {cardImages.map((img, index) => (
                  <img key={index} src={img} alt="card icon" className={styles.cardImage} />
                ))}
              </span>
            ) : (
              <b>{displayLabel || label}</b>
            )}
          </p>
          <button
            className={`btn-theme mt-1 ${locked ? styles.teenpattiSuspended : ""}`}
            onClick={() => !locked && onBetClick(value, betData?.nat || label, type, betData)}
            disabled={locked}
          >
            {!locked && <span>{value || 0}</span>}
          </button>
          <p className="mt-1 mb-0 text-danger text-center" style={{ color: "white" }}>
            {showExposure ? (exposure < 0 ? exposure.toFixed(2) : `+${exposure.toFixed(2)}`) : "0"}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.casinoTableBox}>
      <div className="table-responsive m-t-10 casino-box">
        <table className="table table-bordered m-b-0">
          <thead>
            <tr>
              <th className="box-6"></th>
              <th style={{ fontSize: '10px', backgroundColor: '#72bbef' }} className="box-1 text-center back">BACK</th>
              <th style={{ fontSize: '10px', backgroundColor: '#faa9ba' }} className="box-1 text-center lay">LAY</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="box-6" style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                <b>{data?.[0]?.nat || "Next Total 110 or More"}</b>
                <div className="float-right mr-2">
                  <span className="book-red d-block" style={{ color: "white" }}>0</span>
                  <span className="book-red d-block" style={{ color: "white" }}>0</span>
                </div>
              </td>
              <td className={`box-1 back text-center ${isLocked(data?.[0]?.b, data?.[0]) ? "suspended" : ""}`}>
                {renderOddsBox(data?.[0]?.b, data?.[0]?.nat || "Next Total 110 or More", "back", data?.[0])}
              </td>
              <td className={`box-1 lay text-center ${isLocked(data?.[0]?.l, data?.[0]) ? "suspended" : ""}`}>
                {renderOddsBox(data?.[0]?.l, data?.[0]?.nat || "Next Total 110 or More", "lay", data?.[0])}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="container-fluid container-fluid-5 m-t-10">
        <div className="row row5">
          {renderBetCell(data?.[4]?.b, data?.[4]?.nat || "Even", "even", data?.[4], "Even")}
          {renderBetCell(data?.[5]?.b, data?.[5]?.nat || "Odd", "odd", data?.[5], "Odd")}
          {renderBetCell(
            data?.[3]?.b,
            data?.[3]?.nat || "Red",
            "red",
            data?.[3],
            null,
            [heartIcon, diamondIcon]
          )}
          {renderBetCell(
            data?.[2]?.b,
            data?.[2]?.nat || "Black",
            "black",
            data?.[2],
            null,
            [spadeIcon, clubIcon]
          )}
        </div>
      </div>
    </div>
  );
};

export default BetTableDum10;

